<div class="min-h-screen bg-gray-50">
  <app-header [cartCount]="cartCount"></app-header>

  <!-- Hero Section -->
  <section class="bg-gradient-to-br from-orange-100 via-white to-red-50 py-12">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center">
        <span
          class="inline-flex items-center bg-orange-100 text-orange-600 rounded-full px-4 py-1 text-sm font-medium mb-4">
          <lucide-icon name="tag" class="w-4 h-4 mr-1"></lucide-icon>
          Exclusive Deals
        </span>
        <h1 class="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
          Offers & <span class="text-orange-500">Deals</span>
        </h1>
        <p class="text-xl text-gray-600 max-w-2xl mx-auto">
          Save big on every order with our exclusive offers and promotions
        </p>
      </div>
    </div>
  </section>

  <!-- Main Offers -->
  <section class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
    <h2 class="text-2xl font-bold text-gray-900 mb-6">Top Offers</h2>
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
      <div *ngFor="let offer of mainOffers"
        [class]="'bg-gradient-to-br ' + offer.bgGradient + ' rounded-2xl p-6 text-white relative overflow-hidden group cursor-pointer hover:shadow-xl transition-all duration-300 hover:-translate-y-1'">
        <div class="absolute top-4 right-4 opacity-20 group-hover:opacity-30 transition-opacity">
          <lucide-icon [name]="offer.icon" class="w-24 h-24"></lucide-icon>
        </div>
        <div class="relative z-10">
          <h3 class="text-3xl font-bold mb-1">{{ offer.title }}</h3>
          <p class="text-white/90 text-lg mb-3">{{ offer.subtitle }}</p>
          <p class="text-white/80 text-sm mb-4">{{ offer.description }}</p>
          <div *ngIf="offer.code" class="inline-flex items-center bg-white/20 backdrop-blur-sm rounded-full px-4 py-2">
            <span class="font-mono font-bold">{{ offer.code }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Category Offers -->
  <section class="bg-white py-12">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h2 class="text-2xl font-bold text-gray-900 mb-6">Category Specials</h2>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div *ngFor="let offer of categoryOffers"
          class="bg-gray-50 rounded-2xl overflow-hidden group cursor-pointer hover:shadow-lg transition-all duration-300">
          <div class="h-48 relative overflow-hidden">
            <img [src]="offer.image" [alt]="offer.title"
              class="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
            <div class="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
            <div class="absolute bottom-4 left-4 text-white">
              <p class="text-3xl font-bold">{{ offer.price }}</p>
            </div>
          </div>
          <div class="p-4">
            <h3 class="text-lg font-bold text-gray-900">{{ offer.title }}</h3>
            <p class="text-gray-600 text-sm">{{ offer.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Restaurant Specific Offers -->
  <section class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
    <h2 class="text-2xl font-bold text-gray-900 mb-6">Restaurant Offers</h2>
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <a *ngFor="let restaurant of featuredRestaurants"
        [routerLink]="restaurant.isOn ? ['/restaurant', restaurant.id] : null"
        class="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300 group"
        [class.cursor-not-allowed]="!restaurant.isOn">
        <div class="h-32 relative overflow-hidden">
          <img [src]="restaurant.image" [alt]="restaurant.name"
            class="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />

          <div *ngIf="!restaurant.isOn" class="absolute inset-0 bg-black/50 flex items-center justify-center z-10">

            <div class="bg-white/90 rounded-lg px-3 py-1 shadow-lg">
              <span class="text-xs font-bold text-red-700 tracking-wide">
                COMING SOON
              </span>
            </div>
          </div>

        </div>
        <div class="p-3">
          <h4 class="font-semibold text-gray-900 text-sm truncate">{{ restaurant.name }}</h4>
          <p class="text-teal-600 text-xs font-medium mt-1">{{ restaurant.offer }}</p>
        </div>
      </a>
    </div>
  </section>


  <!-- CTA Section -->
  <section class="bg-gray-900 py-12">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <h2 class="text-2xl md:text-3xl font-bold text-white mb-4">Don't Miss Out on These Deals!</h2>
      <p class="text-gray-400 mb-6">Order now and save big on your favorite food</p>
      <a routerLink="/"
        class="inline-flex items-center bg-orange-500 hover:bg-orange-600 text-white rounded-full px-8 py-4 text-lg font-semibold">
        Order Now
        <lucide-icon name="arrow-right" class="w-5 h-5 ml-2"></lucide-icon>
      </a>
    </div>
  </section>

  <app-footer></app-footer>
</div>